export const nodesData = [
    {
        "data": {
            "id": "AT1G73820",
            "name": "AT1G73820",
            "score": 0.007,
            "type": "gene"
        }
    },
    {
        "data": {
            "id": "AT4G23110",
            "name": "TCO",
            "score": 0.007,
            "type": "gene"
        }
    },
    {
        "data": {
            "id": "AT4G30200",
            "name": "VIL2",
            "score": 0.007,
            "type": "gene"
        }
    },
    {
        "data": {
            "id": "AT2G23380",
            "name": "SET1",
            "score": 0.007,
            "type": "gene"
        }
    },
    {
        "data": {
            "id": "AT1G02580",
            "name": "SDG5",
            "score": 0.007,
            "type": "gene"
        }
    },
    {
        "data": {
            "id": "URS000075325B_3702.232274",
            "name": "URS000075325B_3702.232274",
            "score": 0.007,
            "type": "lncRNA"
        }
    },
    {
        "data": {
            "id": "EL0299",
            "name": "EL0299",
            "score": 0.007,
            "type": "validate_lncRNA"
        }
    }
]

export const edgesData = [
    {
        "data": {
            "source": "EL0299",
            "target": "AT1G02580",
            "weight": 1.0,
            "validate": 0.0
        }
    },
    {
        "data": {
            "source": "EL0299",
            "target": "AT1G73820",
            "weight": 1.0,
            "validate": 0.0
        }
    },
    {
        "data": {
            "source": "EL0299",
            "target": "AT2G23380",
            "weight": 1.0,
            "validate": 0.0
        }
    },
    {
        "data": {
            "source": "EL0299",
            "target": "AT4G23110",
            "weight": 1.0,
            "validate": 0.0
        }
    },
    {
        "data": {
            "source": "EL0299",
            "target": "AT4G30200",
            "weight": - 1,
            "validate": 0.0
        }
    },
    {
        "data": {
            "source": "EL0299",
            "target": "URS000075325B_3702.232274",
            "weight": - 0.5,
            "validate": 0.0
        }
    }
]
